import React from "react";
import ElementProductFinder from "./components/ElementProductFinder";
import {createRoot} from "react-dom/client";

export default () => {

  const doms = document.querySelectorAll('[data-product-finder-element]');
  for (const dom of doms) {
    const json = dom.getAttribute('data-product-finder-element');
    if (json) {
      const root = createRoot(dom);
      root.render(<ElementProductFinder
        configs={JSON.parse(json)}/>);
    }
  }
}
